import { Component, computed, effect, inject, OnInit } from '@angular/core';
import { CardComponent } from './components/card/card.component';
import { CustomRouteService } from 'src/app/pages/custom-route/services/custom-route.service';
import { PlannerDayStateService } from '../../../../services/planner-day-state.service';
import { PlannerViewsStateService } from '../../../../services';
import { RouteTimelineService } from '../../services/route-timeline.service';
import { TranslateService } from '@ngx-translate/core';
import { MatDialogService } from 'src/app/services/mat-dialog.service';
import { StandardDialog } from 'src/app/shared/dialogs';

@Component({
  selector: 'app-points',
  standalone: true,
  imports: [
    CardComponent,
],
  templateUrl: './points.component.html',
  styleUrls: ['./points.component.scss'],
})
export class PointsComponent implements OnInit {
  // Service injections
  private _customRouteService = inject(CustomRouteService);
  private _plannerDayStateService = inject(PlannerDayStateService);
  private _routeTimelineService = inject(RouteTimelineService);
  private _matDialogService = inject(MatDialogService);
  private _translateService = inject(TranslateService);
  private _plannerViewsStateService = inject(PlannerViewsStateService);
  
  // State service signals
  private _customRouteData = this._customRouteService.customRouteData;
  private _dayToShowIndex = this._plannerDayStateService.dayToShowIndex;

  // Computed properties
  private _dailyCustomRouteData = computed(() =>
    this._customRouteData().dailyRoutes[this._dayToShowIndex()]
  );
  protected dailyPoints = computed(() =>
    this._dailyCustomRouteData().points
  );
  private _now = computed(() => this._routeTimelineService.now());
  protected pointStatuses = computed(() =>
    this.dailyPoints().map(point =>
      this._routeTimelineService.getCardStatusFromSegmentTime(point, this._now()))
  );
  
  // Local properties
  public previousTitles: string[] = []; // TODO: CAMBIAR A OBJETO DE TRADUCCIONES

  // Effects: 
  setPreviousTitles = effect(() => {
    if (this.dailyPoints()) {
      this.previousTitles = this.dailyPoints().map((_p, i) =>
        i === 0 ? this._dailyCustomRouteData().startPoint.address : this.dailyPoints()[i - 1].title
      );
    }
  }, { allowSignalWrites: true });
  
  checkDailyPoints = effect(() => {
    console.log('Daily Points:', this.dailyPoints());
  }, { allowSignalWrites: true });
  
  // Lifecycle hooks
  ngOnInit(): void {
    const dailyPoints = this.dailyPoints();
    if(dailyPoints.length === 0) {
      this._openNoPointsDialog();
    }
  }
  
  // Methods
  /**
   * Opens a dialog informing the user that no points were found
   * and suggesting to edit the route to add more points.
   */
  private _openNoPointsDialog(): void {
    const dialogRef = this._matDialogService.openMatDialog({
      component: StandardDialog,
      data: {
        iconName: 'alert',
        title: this._translateService.instant('No se encontraron recursos'),
        content: this._translateService.instant('Parece que según tus intereses se han configurado todos los recursos disponibles. Pulsa en “Editar ruta” y añade los recursos que más te interesen para tener una ruta completa.'),
        primaryActionButtonText: this._translateService.instant('Editar ruta'),
        secondaryActionButtonText: this._translateService.instant('Cancelar'),
        handleClickPrimaryButton: () => {
          this._plannerViewsStateService.isEditRouteView.set(true);
          dialogRef.close();
        },
        handleClickSecondaryButton: () => {
          dialogRef.close();
        }
      }
    })
  }
}
